module.exports = __webpack_public_path__ + "static/img/lmt.72e8b52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/summit/lmt.png
// module id = ZIoW
// module chunks = 1